var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "leak-investigation-reports-search-filters" },
    [
      _c(
        "b-card",
        { staticClass: "bg-light shadow-sm border-0 rounded-xl" },
        [
          _c(
            "b-form",
            {
              staticClass: "d-flex justify-content-between",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _setup.handleSearch.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "flex-fill mr-3" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12", lg: "4" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("b-form-select", {
                            staticClass: "rounded-pill",
                            attrs: {
                              id: "tenant-id",
                              options: _setup.tenantOptions,
                            },
                            on: { input: _setup.handleTenantChange },
                            scopedSlots: _vm._u([
                              {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-form-select-option",
                                      { attrs: { value: null } },
                                      [
                                        _vm._v(
                                          "\n                  All Tenants\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _setup.localFilters.tenantId,
                              callback: function ($$v) {
                                _vm.$set(_setup.localFilters, "tenantId", $$v)
                              },
                              expression: "localFilters.tenantId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "12", lg: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "From",
                            horizontal: "",
                            "label-for": "date-from",
                            "label-cols": "2",
                          },
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "rounded-pill",
                            attrs: {
                              id: "date-from",
                              type: "date",
                              disabled: _vm.loading,
                            },
                            on: { input: _setup.onFilterChange },
                            model: {
                              value: _setup.localFilters.dateFrom,
                              callback: function ($$v) {
                                _vm.$set(_setup.localFilters, "dateFrom", $$v)
                              },
                              expression: "localFilters.dateFrom",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "12", lg: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "To",
                            horizontal: "",
                            "label-for": "date-to",
                            "label-cols": "2",
                          },
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "rounded-pill",
                            attrs: {
                              id: "date-to",
                              type: "date",
                              disabled: _vm.loading,
                            },
                            on: { input: _setup.onFilterChange },
                            model: {
                              value: _setup.localFilters.dateTo,
                              callback: function ($$v) {
                                _vm.$set(_setup.localFilters, "dateTo", $$v)
                              },
                              expression: "localFilters.dateTo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "12", lg: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "LeakBot ID",
                            horizontal: "",
                            "label-for": "leakbot-search",
                            "label-cols": "2",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                staticClass: "rounded-pill",
                                attrs: {
                                  id: "leakbot-search",
                                  placeholder: "Enter LeakBot ID...",
                                  disabled: _vm.loading,
                                },
                                on: { input: _setup.onFilterChange },
                                model: {
                                  value: _setup.localFilters.leakbotId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _setup.localFilters,
                                      "leakbotId",
                                      $$v
                                    )
                                  },
                                  expression: "localFilters.leakbotId",
                                },
                              }),
                              _vm._v(" "),
                              _setup.localFilters.leakbotId
                                ? _c(
                                    "b-input-group-button",
                                    {
                                      staticClass: "ml-3",
                                      attrs: { slot: "right" },
                                      slot: "right",
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "outline-secondary",
                                          },
                                          on: {
                                            click: _setup.clearLeakBotFilter,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-times",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "12", lg: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Partner Reference",
                            horizontal: "",
                            "label-for": "partner-ref-search",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                staticClass: "rounded-pill",
                                attrs: {
                                  id: "partner-ref-search",
                                  placeholder: "Enter Partner Reference...",
                                  disabled: _vm.loading,
                                },
                                on: { input: _setup.onFilterChange },
                                model: {
                                  value: _setup.localFilters.partnerReference,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _setup.localFilters,
                                      "partnerReference",
                                      $$v
                                    )
                                  },
                                  expression: "localFilters.partnerReference",
                                },
                              }),
                              _vm._v(" "),
                              _setup.localFilters.partnerReference
                                ? _c(
                                    "b-input-group-button",
                                    {
                                      staticClass: "ml-3",
                                      attrs: { slot: "right" },
                                      slot: "right",
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "outline-secondary",
                                          },
                                          on: {
                                            click:
                                              _setup.clearPartnerReferenceFilter,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-times",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "12", lg: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Work Order Number",
                            horizontal: "",
                            "label-for": "work-order-search",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                staticClass: "rounded-pill",
                                attrs: {
                                  id: "work-order-search",
                                  placeholder: "Enter Work Order Number...",
                                  disabled: _vm.loading,
                                },
                                on: { input: _setup.onFilterChange },
                                model: {
                                  value: _setup.localFilters.workOrderNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _setup.localFilters,
                                      "workOrderNumber",
                                      $$v
                                    )
                                  },
                                  expression: "localFilters.workOrderNumber",
                                },
                              }),
                              _vm._v(" "),
                              _setup.localFilters.workOrderNumber
                                ? _c(
                                    "b-input-group-button",
                                    {
                                      staticClass: "ml-3",
                                      attrs: { slot: "right" },
                                      slot: "right",
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "outline-secondary",
                                          },
                                          on: {
                                            click: _setup.clearWorkOrderFilter,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-times",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-3 d-flex flex-column align-items-center" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "font-weight-bold",
                      attrs: {
                        disabled:
                          _vm.loading ||
                          _vm.exportingCsv ||
                          _vm.totalReports === 0,
                        variant: "outline-brand-secondary",
                      },
                      on: { click: _setup.handleExportCsv },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.exportingCsv ? "Exporting..." : "Export CSV"
                          ) +
                          "\n          "
                      ),
                      _vm.exportingCsv
                        ? _c("i", { staticClass: "fa fa-spinner fa-spin me-1" })
                        : _vm.totalReports > 0
                        ? _c(
                            "small",
                            { staticClass: "ms-1 font-weight-bold" },
                            [
                              _vm._v(
                                "[" + _vm._s(_vm.totalReports) + " records]"
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 font-weight-bold",
                      attrs: {
                        type: "submit",
                        variant: "primary",
                        disabled: _vm.loading,
                      },
                    },
                    [
                      _c("span", { staticClass: "px-3" }, [
                        _vm._v(_vm._s(_vm.loading ? "Searching..." : "Search")),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }